import { mapGetters } from 'vuex'
import { EventBus } from '@/services//EventBus.js'
import Modal from '@/components/modal/Modal.vue'

export default {
    name: 'App',
    inject: ['auth'],
    data() {
        return {
            timeout: null,
            resizing: false,
            version: 2,
            error: null,
            isIE: false,
        }
    },
    computed: {
        ...mapGetters({
            activeMap: 'getActiveMap',
        })
    },
    created() {
        let version = parseInt(localStorage.getItem('version'))

        if (version < this.version)
            localStorage.clear()

        localStorage.setItem('version', this.version)

        EventBus.$on('error', data => {
            this.error = data
        })

        const ua = window.navigator.userAgent.toLowerCase();

        if ((/trident/gi).test(ua) || (/msie/gi).test(ua)) {
            this.isIE = true;
            EventBus.$emit('error', {
                message: 'global.errorIE',
            });
        }
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.resizing = true
            clearTimeout(this.timeout)

            this.timeout = setTimeout(() => {
                this.resizing = false
            }, 200)
        })
    },
    watch: {
        resizing(value) {
            EventBus.$emit('resize:' + (value ? 'start' : 'end'))
        },
        activeMap(map, prev) {
            const isSame = (map && prev && map.id == prev.id && map.group.id == prev.group.id)
            if (!isSame) {
                if (prev) {
                    this.subscribeObjectChanges(prev, 'delete')
                }
                if (map) {
                    this.subscribeObjectChanges(map)
                }
            }
        }
    },
    methods: {
        rootClick: function() {
            EventBus.$emit('root-click')
        },
        mouseup: function() {
            EventBus.$emit('mouseup')
        },
        mousemove: function(e) {
            EventBus.$emit('mousemove', e)
        },
        subscribeObjectChanges(mapObject, action = 'add') {
            mapObject.objects
              .filter(item => item.type !== 'LEVEL' && item.type !== 'CAM')
              .forEach(o => {
                this.$store.state.wsWebConnect.send(JSON.stringify({
                  type: 'subscribe',
                  data: {
                    [`${action}_rules`]: [
                      {
                        type: o.type,
                        id: o.id,
                        action: 'STATE_CHANGED'
                      }
                    ]
                  }
                }))
            })
        }
    },
    components: {
        Modal,
    }
}



// WEBPACK FOOTER //
// ./src/modules/app/app.js